<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { any } from 'vue-types';

import getBreadcrumbs from './getBreadcrumbs';

import keyRoutesEnum from '@/router/keyRoutesEnum';

export default defineComponent({
  name: 'Breadcrumbs',
  props: {
    class: any(),
  },
  setup() {
    const route = useRoute();
    const breadcrumbs = computed(() => getBreadcrumbs(route));
    return {
      keyRoutesEnum,
      breadcrumbs,
    };
  },
});
</script>

<template>
  <nav
    aria-label="Breadcrumb"
    :class="['flex text-xs items-center breadcrumb opacity-70 hover:opacity-100', $props.class]"
  >
    <li class="mr-3 list-none">
      <NuxtLink aria-label="Home icon" :to="keyRoutesEnum.dashboard">
        <FaIcon :icon="['fas', 'home']" />
      </NuxtLink>
    </li>
    <li
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="breadcrumb.to"
      class="mr-2 list-none"
    >
      <span v-if="index + 1 === breadcrumbs.length" class="capitalize">
        {{ breadcrumb.text }}
      </span>
      <span v-else>
        <NuxtLink :to="breadcrumb.to" class="capitalize">
          {{ breadcrumb.text }}
        </NuxtLink>
      </span>
    </li>
  </nav>
</template>

<style lang="scss">
.breadcrumb {
  li:not(:first-child)::before {
    font-weight: 400;
    color: #999;
    content: "/";
    margin-right: 10px;
  }
}
</style>
